import getFileExtension from './getFileExtension'

const ACCEPTED_FILE_EXTENSIONS = 'gif png jpeg jpg'.split(' ')

export default file => {
  const ext = getFileExtension(file)

  return ACCEPTED_FILE_EXTENSIONS.includes(ext)
}
